import React from 'react';
import { Check, X } from 'lucide-react';
export function ComparisonTable() {
  return <div className="w-full max-w-md mx-auto my-8 bg-black/50 backdrop-blur-md rounded-xl overflow-hidden border border-white/20" data-id="element-63">
      <div className="grid grid-cols-2 text-center" data-id="element-64">
        <div className="bg-red-900/40 p-3 border-b border-white/10" data-id="element-65">
          <h4 className="text-red-400 font-bold text-sm sm:text-base leading-tight" data-id="element-66">
            Sin Tenis Pro System
          </h4>
        </div>
        <div className="bg-tennis-green/40 p-3 border-b border-white/10" data-id="element-67">
          <h4 className="text-tennis-yellow font-bold text-sm sm:text-base leading-tight" data-id="element-68">
            Con Tenis Pro System
          </h4>
        </div>
      </div>

      <div className="divide-y divide-white/5" data-id="element-69">
        {[['Cansancio en el 2do set', 'Energía hasta el tie-break'], ['Saque débil y predecible', 'Saque potente y pesado'], ['Llegás tarde a las pelotas', 'Movilidad explosiva'], ['Dolores post-partido', 'Recuperación rápida'], ['Entrenamiento al azar', 'Plan paso a paso']].map((row, i) => <div key={i} className="grid grid-cols-2 text-sm" data-id="element-70">
            <div className="p-3 flex items-center gap-2 text-gray-300 bg-red-900/10" data-id="element-71">
              <X className="w-4 h-4 text-red-500 flex-shrink-0" data-id="element-72" />
              <span className="leading-tight" data-id="element-73">{row[0]}</span>
            </div>
            <div className="p-3 flex items-center gap-2 text-white bg-tennis-green/10" data-id="element-74">
              <Check className="w-4 h-4 text-tennis-green flex-shrink-0" data-id="element-75" />
              <span className="leading-tight font-medium" data-id="element-76">{row[1]}</span>
            </div>
          </div>)}
      </div>
    </div>;
}